import { FloatingFormItem } from '@/components/_common';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import { bankConfig } from '@/core/domain/financial/Boletos/Boletos.dictionary';
import { Col, Select, Tooltip, Input, Divider, Typography } from 'antd';

interface Props {
  bankAccount?: BankAccount;
}

export default function AgreementInstantRegisterFields({ bankAccount }: Props) {
  const bankMapFields = bankAccount ? bankConfig[bankAccount?.bank.code] : null;

  return (
    <>
      <Col span={24}>
        <Divider />

        <Typography.Title level={4}>
          Informações relacionadas a API do banco
        </Typography.Title>
      </Col>

      {!!bankMapFields?.fields.agreementWebServiceType && (
        <Col span={24} md={12} lg={6} xxl={8}>
          <FloatingFormItem
            label="Convênio tipo webService"
            name={['general', 'agreementWebServiceType']}
          >
            <Select
              allowClear
              style={{ width: '100%' }}
              options={bankMapFields?.fields.agreementWebServiceType.options?.map(
                (value) => ({ value, label: value }),
              )}
            />
          </FloatingFormItem>
        </Col>
      )}

      {!!bankMapFields?.fields.agreementHybridEmission?.visible && (
        <Tooltip trigger="click" title="Layout adotado pelo Banco">
          <Col span={24} md={12} lg={6} xxl={4}>
            <FloatingFormItem
              label="Hibrido"
              name={['general', 'agreementHybridEmission']}
            >
              <Select
                style={{ width: '100' }}
                options={[
                  {
                    value: 1,
                    label: 'Sim',
                  },
                  {
                    value: 0,
                    label: 'Não',
                  },
                ]}
                allowClear
              />
            </FloatingFormItem>
          </Col>
        </Tooltip>
      )}

      <Tooltip trigger="click" title="Layout adotado pelo Banco">
        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Estação"
            name={['general', 'agreementStation']}
          >
            <Input maxLength={20} />
          </FloatingFormItem>
        </Col>
      </Tooltip>

      <Tooltip
        trigger="click"
        title="Informe o client_id disponibilizado pelo banco."
      >
        <Col span={24} md={12} lg={6} xxl={8}>
          <FloatingFormItem label="Api Id" name={['general', 'agreementApiId']}>
            <Input />
          </FloatingFormItem>
        </Col>
      </Tooltip>

      <Tooltip
        trigger="click"
        title="Informar o developer_application_key disponibilizado pelo banco."
      >
        <Col span={24} md={12} lg={6} xxl={8}>
          <FloatingFormItem
            label="Chave Key"
            name={['general', 'agreementApiKey']}
          >
            <Input />
          </FloatingFormItem>
        </Col>
      </Tooltip>

      <Tooltip
        trigger="click"
        title="Informar o client_secret disponibilizado pelo banco."
      >
        <Col span={24} md={12} lg={6} xxl={8}>
          <FloatingFormItem
            label="Segredo"
            name={['general', 'agreementApiSecret']}
          >
            <Input />
          </FloatingFormItem>
        </Col>
      </Tooltip>

      {!!bankMapFields?.fields.agreementAilosPassword && (
        <Tooltip
          trigger="click"
          title="Verificar senha diretamente com o banco"
        >
          <Col span={24} md={12} lg={6} xxl={8}>
            <FloatingFormItem
              label="Senha de Autenticação Ailos"
              name={['general', 'agreementAilosPassword']}
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Tooltip>
      )}
    </>
  );
}
